import React from 'react'
import Grid from '@mui/material/Grid2'
import Image from '@/components/image/Image'
import Divider from '@/components/divider/Divider'
import CurrentEvent from '@/components/currentEvent/CurrentEvent'

const UpcommingEvents: React.FC = () => {
  return (
    <Grid
      container
      direction="row"
      columnSpacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <CurrentEvent />

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid size={11}>
        <h2>Återkommande Events</h2>
      </Grid>

      <Grid
        container
        direction="row"
        columnSpacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Sankt Georgsdagen</h3>
          <p style={{ textAlign: 'left' }}>
            Den 23 april firar vi Sankt Georgsdagen med Sjöscouterna, antingen
            vid Scoutstugan eller i Näsviken.
          </p>
          <Image src="/images/events/st-george.jpg" alt="Saint George" />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Valborgsmässoafton</h3>
          <p style={{ textAlign: 'left' }}>
            Den 30 april spelar vi i Snäckan, Rosengården, och firar in våren
            med hela scoutkåren - en tradition sedan 1924.
          </p>
          <Image src="/images/events/valborg.jpg" alt="Valborg" />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Blåsmusikens dag</h3>
          <p style={{ textAlign: 'left' }}>
            Varje år på Blåsmusikens Dag, den sista lördagen i maj, spelar vi på
            Karlshamns torg tillsammans med Karlshamns Musikskola och Karlshamns
            Musikkår.
          </p>
          <Image
            src="/images/events/blasmusikens-dag.jpg"
            alt="Blåsmusikens dag"
          />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Kastellets dag</h3>
          <p style={{ textAlign: 'left' }}>
            Varje år på Kastellets dag, början av juni, spelar vi på Kastellet.
            Samtidigt invigs nya medlemmar i Castellanerna, Lions säljer
            våfflor, Teatersmedjan håller öppen repetition och syrenerna står i
            blom.
          </p>
          <Image src="/images/events/kastellets-dag.jpg" alt="Kastellets dag" />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Östersjöfestivalen</h3>
          <p style={{ textAlign: 'left' }}>
            Vi klär ut oss, marscherar i den årliga festivalparaden och håller
            konserter i staden.
          </p>
          <Image
            src="/images/events/ostersjofestivalen.jpg"
            alt="Östersjöfestivalen"
          />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Kulturnatten</h3>
          <p style={{ textAlign: 'left' }}>
            I oktober deltar vi på Kulturnatten, där vi spelar vid Mieån en
            stund innan Scouternas årliga Ljusregatta.
          </p>
          <Image
            src="/images/events/kulturnatten-2024.jpg"
            alt="Kulturnatten"
          />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Tomteparaden första advent</h3>
          <p style={{ textAlign: 'left' }}>
            Vi marscherar i tomtekläder genom stan under julskyltningen och
            avslutar på torget, där vi bjuder in stora som små till dans kring
            granen.
          </p>
          <Image
            src="/images/events/santa-claus-parade.jpg"
            alt="Tomteparaden"
          />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Julmarknaden i Lübeck andra advent</h3>
          <p style={{ textAlign: 'left' }}>
            Varje år beger vi oss till Lübeck, julmarknadernas huvudstad, och
            sprider musik och glädje på gatorna. Efteråt belönar vi oss själva
            med julgodis, skratt och skönt häng - och alla slantar vi spelar in
            går oavkortat till ett besök på stadens indiska restaurang.
          </p>
          <Image src="/images/events/lübeck-2022.jpg" alt="Lübeck" />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />

        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Julaftonsdans på torget</h3>
          <p style={{ textAlign: 'left' }}>
            Vi sprider julglädje till dem som annars firar ensamma.
          </p>
          <Image src="/images/events/christmas-eve.jpg" alt="Julafton" />
        </Grid>

        <Divider size={{ xs: 11, md: 0 }} />
      </Grid>
    </Grid>
  )
}

export default UpcommingEvents
